<div *ngIf="show || (show === undefined && global$ | async)" [ngClass]="classes" [style.width]="cntWidth">
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
